import { Form, Input } from 'antd';
import React from 'react';

import type { EmailInputProps } from './types';

import { RULES } from '@/constants';

export const EmailInput: React.FC<EmailInputProps> = ({ label, placeholder }) => (
  <Form.Item name="email" label={label} rules={[RULES.REQUIRED, RULES.EMAIL]}>
    <Input type="email" data-test="email" name="email" placeholder={placeholder} />
  </Form.Item>
);
